import React from 'react'
import AboutUs from '../components/AboutUs'

const AboutUsPage = (props) => (
  <AboutUs router={props} />
)

export default AboutUsPage



// WEBPACK FOOTER //
// ./src/pages/AboutUsPage.js